import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Asset} from '../../models/cms/asset';

@Injectable({
  providedIn: 'root'
})
export class AssetService extends AbstractModelService<Asset> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/asset', Asset);
  }
}
